/*
 *		Copyright (c) 2011-2018 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

'use strict';

angular.module('access.Account')
    .factory('CloudPlatformIdentityProvider', [
        'CloudPlatformAccountServerRequest',
        'CloudPlatformUserInfo',
        function (CloudPlatformAccountServerRequest, CloudPlatformUserInfo) {
            var IDENTITY_PROVIDERS_ENDPOINT = '/api/2/identity_providers';
            var CLOUD_PLATFORM_INTERNAL_IDP_TYPE = 'internal';
            var identityProviderPromise;

            return {
                getResetPasswordLink: function () {
                    return _getIdentityProvider().then(function (provider) {
                        return provider.forgot_password_url;
                    });
                },
                canChangeCloudPlatformName: function () {
                    return _getIdentityProvider().then(function (provider) {
                        return CLOUD_PLATFORM_INTERNAL_IDP_TYPE === provider.idp_type;
                    });
                }
            };

            function _getIdentityProvider() {
                if (angular.isUndefined(identityProviderPromise)) {
                    identityProviderPromise = CloudPlatformUserInfo.getMe()
                        .then(function (response) {
                            var idpId = response.idp_id;

                            return CloudPlatformAccountServerRequest.get(IDENTITY_PROVIDERS_ENDPOINT + '/' + idpId);
                        });
                }

                return identityProviderPromise;
            }
        }]);

